import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';

export function sliderComparison() {
    document.addEventListener( 'DOMContentLoaded', function () {
        const sliderComparison = document.querySelectorAll('.sliderComparison');
        if(sliderComparison){

       

        sliderComparison.forEach(block=>{
            new Splide(block, {
              perPage: 1,
              perMove: 1,
              autoplay: false,
              interval: 5500,
              pagination: false,
              arrows: true,
              padding: '0rem',
              drag: false,
              dragging: false,
              noDrag: 'input, textarea, .no-drag',
              
              breakpoints: {
                1100: {
                  perPage : 1,
                  perMove : 1,
                },
                840: {
                  perPage : 1,
                  perMove : 1,
                  pagination : false,
 
                }
              }
              }).mount();
        });
      }
    })
}